const clientId = '5ebba1c95cacc514f80bee25'
export default clientId
